<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('finance_tags')">
            <app-default-button
                :title="$fieldTitle('add', 'tag', true)"
                v-if="$can('create_interview_tag')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="finance-tag-table"
            :options="options"
            @action="triggerActions"
        />

        <app-finance-tag-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('finance-tag-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../common/Mixin/Global/HelperMixin";
import FinanceTagMixins from "../../Mixins/FinanceTagMixins";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";

export default {
    name  : "AppFinanceTags",
    mixins: [HelperMixin, FinanceTagMixins],
    data() {
        return {
            isModalActive: false,
            selectedUrl  : '',
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/finance-tags/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    }
}
</script>

